var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNrgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 3.80005L17 8.86449L12.0004 13.9259L10.0002 11.9013L13.0002 8.86449L12.0004 7.85199L8.00009 11.9013L12.0004 15.9507L18.0002 9.87651L20 11.9013L12.0004 20L4 11.9013L12.0026 3.80005Z",
    fill: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrgChrome);
export default __webpack_public_path__ + "static/media/nrg-chrome.019bc5541c4b628fb89496d5f99e8b8c.svg";
export { ForwardRef as ReactComponent };